<template>
  <div class="tw-relative tw-mt-10">
    <section class="tw-mb-10">
      <incidents-list />
    </section>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from "vue-i18n";

import IncidentsList from "@/modules/PhishTitan/views/Common/Incidents/Overview/IncidentsList.vue";
import { usePageMetaStore } from "@/store/pageMeta.store";

const { t } = useI18n();
const pageMetaStore = usePageMetaStore();
const setPageTitle = (title: string) => pageMetaStore.setPageTitle({ title });

setPageTitle(t("incidents-legend"));
</script>
